import { useState, useMemo } from "react";
import { getFloorsByBuildingId, getPreferences, useAppSelector } from "@lib/store";

export const useHereAndNowFloorSelection = (buildingId: string) => {
  const allPreferences = useAppSelector(getPreferences);
  const floors = useAppSelector(state => getFloorsByBuildingId(state, buildingId));
  const floorIdSet = useMemo(() => new Set(floors.map(floor => floor.id)), [floors]);
  const sortedFloors = useMemo(() => [...floors].sort((a, b) => a.number - b.number), [floors]);

  const [selectedFloorId, setSelectedFloorId] = useState<string | null>(null);
  const preferredFloorId = allPreferences.workspaceLocation?.floorId;
  const lowestFloorId = sortedFloors.at(0)?.id;

  const exposedFloorId =
    [selectedFloorId, preferredFloorId, lowestFloorId].find(id => id && floorIdSet.has(id)) ?? null;

  return [exposedFloorId, setSelectedFloorId] as const;
};
